import { Divider, Typography } from '@pankod/refine-antd';
import styles from './ProductFooter.module.css';

const { Text } = Typography;

interface ProductFooterProps {
  subTotal: number;
  vatAmount: number;
  vatPercentage: number;
  shipmentCost: number;
  netTotal: number;
  discountCost: number;
  // Sales pass the entered invoice discount (10% or TK 200); purchases print the taka discountCost.
  discountLabel?: string;
}

export const ProductFooter: React.FC<ProductFooterProps> = ({
  subTotal,
  vatAmount,
  vatPercentage,
  shipmentCost,
  netTotal,
  discountCost,
  discountLabel,
}) => {
  return (
    <div className={styles['product-footer']}>
      <Text>Sub-Total: {subTotal}</Text>
      <Divider />

      <div>
        <Text style={{ visibility: 'hidden' }}>
          Vat: {vatAmount} ({`${vatPercentage}%`}),
        </Text>
        <Text style={{ marginLeft: '1rem', visibility: 'hidden' }}>Shipment: {shipmentCost}</Text>
        <Text>Invoice Discount: {discountLabel ?? discountCost}</Text>
      </div>

      <Divider />
      <Text>Net-Total: {netTotal}</Text>
    </div>
  );
};
